module.exports = __webpack_public_path__ + "assets/img/attribute-info.21a77d92.svg";